import { GREY_400 } from '@mnd-frontend/ui';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const ScrollableContent = styled.div<{ $minWidth: string }>`
  min-width: ${({ $minWidth }) => $minWidth};
  @container (max-width: ${({ $minWidth }) => $minWidth}) {
    padding-right: 1rem;
  }
`;
const ScrollWrapper = styled.div<{ $minWidth: string }>`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  @container (max-width: ${({ $minWidth }) => $minWidth}) {
    box-shadow: inset -1rem 0px 1rem -1rem ${GREY_400};
  }
`;
const Container = styled.div`
  container-type: inline-size;
  position: relative;
`;

export const ScrollContainer = ({
  children,
  minWidth,
}: {
  children: ReactNode;
  minWidth: string;
}) => {
  return (
    <Container>
      <ScrollWrapper $minWidth={minWidth}>
        <ScrollableContent $minWidth={minWidth}>{children}</ScrollableContent>
      </ScrollWrapper>
    </Container>
  );
};
